(function ($) {
    'use strict';

    /**
     * Custom file input with a list of selected files
     * @returns {jQuery}
     */
    $.fn.fileInput = function () {
        const $container = $(this);
        const $input = $container.find('input[type="file"]');
        const $fileInfoHolder = $container.find('.js-file-info');

        const $closeSVGTemplate = $('<svg><use xlink:href="#ic_close"></use></svg>')

        /**
         * Get file size string with unit in human-readable format
         * @param {number} size - file size in bytes
         * @returns {string}
         */
        const getFileSizeWithUnit = function (size) {
            const units = ['Б', 'КБ', 'МБ', 'ГБ', 'ТБ'];
            let power = 0; // initial unit set to Bytes
            let resultSize = size;
            while (resultSize > 1024 && power < units.length) {
                resultSize = resultSize / 1024;
                power++;
            }
            return Number(resultSize.toFixed(2)) + ' ' + units[power];
        };

        /**
         * Generate file list markup
         */
        const renderFileList = function (file) {
            const reader = new FileReader();
            reader.readAsDataURL(file);

            reader.onloadend = function() {
                $fileInfoHolder.addClass('active').empty();
                $('<div>', {
                    class: 'js-file-holder file-holder',
                    append: [
                        $('<div>', {
                            class: 'file-info__img',
                            append: $('<img>', {
                                src: reader.result,
                                title: file.name,
                                alt: file.name
                            })
                        }),
                        $('<div>', {
                            class: 'file-info__left',
                            append: [
                                $('<div>', {
                                    class: 'file-info__row',
                                    append: [
                                        $('<span>', {
                                            class: 'file-info__name',
                                            text: file.name,
                                            title: file.name
                                        }),
                                        $('<span>', {
                                            class: 'file-info__size',
                                            text: getFileSizeWithUnit(file.size)
                                        }),
                                        $('<button>', {
                                            class: 'file-info__close js-file-remove',
                                            type: 'button',
                                            append: $closeSVGTemplate.clone()
                                        })
                                    ]
                                }),
                                $('<button>', {
                                    type: 'button',
                                    class: 'file-info__change js-file-change',
                                    text: 'Заменить'
                                })
                            ]
                        }),

                    ]
                }).appendTo($fileInfoHolder);
            }
        };

        const deleteFile = () => {
            $input.val('');
            $fileInfoHolder.removeClass('active')
                .find('.js-file-holder')
                .remove();
        };

        /**
         * Events listeners
         */
        const initEvents = () => {
            $input.on('change', function (e) {
                renderFileList(this.files[0]);
            });

            $fileInfoHolder.on('click', '.js-file-remove', function () {
                deleteFile();
            });

            $fileInfoHolder.on('click', '.js-file-change', function () {
                $input.trigger('click');
            });
        };

        const init = () => {
            initEvents();
        };

        init();

        return this;
    };
})(jQuery);
